import HeaderState from './header.state'

export const initialState: HeaderState = {
    payer: {
        firstName: '',
        lastName: '',
    },
    activeSection: '/overview',
}
